<div class="flex justify-center pt-4 pb-6">
    <h3 class="text-center"><b>Waiting for payment confirmation...</b></h3>
</div>  
<div class="flex justify-center pt-4 pb-8">
    <mat-spinner></mat-spinner>
</div>
